<template>
    <b-container fluid class="img-bg">
        <b-row no-gutters>
            <b-col sm class="header-column">
                <AdminBar title="Napoli Sotterranea Tour"></AdminBar>
            </b-col>
        </b-row>
        <b-row no-gutters class="mainrow w-100">
            <b-col>
                <div class="panel tourbox">
                    <generic-table ref="table" :fields="fields" :filters="filters" :actions="actions" @remove="requestRemoveEvent" @hostview="openHostView"></generic-table>
                </div>
            </b-col>
        </b-row>

        <b-modal
                id="delete-request"
                ref="modal"
                title="Attenzione!"
                centered
                @ok="removeEvent"
        >
            <p class="my-2">La rimozione di un record non è reversibile</p>
            <p class="my-2">Sicuro di voler continuare?</p>
        </b-modal>

    </b-container>
</template>

<script>
    import AdminBar from "./AdminBar";
    import moment from 'moment'
    import genericTable from "./genericTable";

    moment.locale('IT');

    export default {
        name: "AdminTickets",
        data () {
            return {
                unsubscribe_listener: null,
                deleterequest: null,
                fields: [
                    { key: 'id', label: 'ID', sortable: true, sortDirection: 'desc' },
                    { key: 'start', label: 'Start', sortable: true, class: 'text-center' },
                    { key: 'end', label: 'End', sortable: true, class: 'text-center' },
                    { key: 'occupancy', label: 'Capienza', sortable: true, class: 'text-center' },
                    { key: 'available_seats', label: 'Posti Disponibili', sortable: true, class: 'text-center' },
                    { key: 'tour', label: 'Dati Tour', sortable: true, class: 'text-center' },
                    { key: 'actions', label: 'Azioni'}
                ],
                filters:[
                ],
                actions:[
                    {label:null, event:'remove', icon:'b-icon-trash', variant:'outline-dark'},
                    {label:null, event:'hostview', icon:'b-icon-compass', variant:'outline-dark'}
                ],
                dev:[
                    {stuff:''}
                ]
            }
        },
        components: {
            AdminBar,
            genericTable
        },
        methods: {
            requestRemoveEvent: function(_ticket){
                this.deleterequest = _ticket;
                this.$refs['modal'].show();
            },
            removeEvent: function() {
                if(!this.deleterequest){
                    return;
                }

                let _event = this.deleterequest;
                this.$firebase.eventsCollection.doc(_event.id).delete().then(function() {
                    console.log("Event successfully deleted!");
                }.bind(this)).catch(function(error) {
                    console.error("Error removing document: ", error);
                });
            },
            openHostView: function (_event) {
                let routeData = this.$router.resolve({name: 'host_tour', params: { channel: _event.id, folder: _event.tour.Origin} });
                window.open(routeData.href, '_blank');
            },
        },
        mounted() {
            let self = this;

            this.unsubscribe_listener = this.$firebase.eventsCollection.onSnapshot( function(querySnapshot) {
                self.$refs.table.clearRecords();
                querySnapshot.forEach(function (doc) {
                    let firebase_event = doc.data()
                    let full_event = {
                        id: doc.id,
                        title : firebase_event.title,
                        start : firebase_event.start.seconds,
                        end : firebase_event.end.seconds,
                        available_seats: firebase_event.available_seats,
                        occupancy: firebase_event.occupancy,
                        tour : firebase_event.tour
                    }
                    self.$refs.table.addRecord(full_event);
                });
            });
        },
        beforeDestroy() {
            this.unsubscribe_listener();
        }
    }
</script>

<style scoped>

    .header-column{
        margin-top:1.5%;
        margin-bottom:1.5%;
    }

    .img-bg{
        background-image: url("../../public/ns_bg.jpg");
        background-size: cover;
        background-position: center;
        padding:0;
        height:100%;
        overflow:auto;
    }

    .panel{
        background-color:#fff;
        margin:3px;
        padding:5px;
        border-radius:5px;
    }

    .tourbox{
        border: 5px solid transparent;
        outline: 1px solid #000;
        outline-offset: -5px;
    }

    .mainrow{
        min-height:85%;
        padding: 0 10px 0 10px;
    }

</style>
